export const designSevenPagePath = {
  home: '/home',
  personalPlan: '/personal-plan',
  sample: {
    root: 'sample-path/*',
    example: 'example',
    single: 'single/:id',
    wrongPath: 'wrong-path',
  },
  employees: {
    root: 'employees/*',
    employee: ':id',
    competences: ':id/competences',
    resourcePlannerOldUrl: 'resource-planner',
  },
  projects: {
    resourcePlanner: '/projects/resource-planner',
    searchProjects: '/projects/search-projects',
    moveHours: '/projects/move-hours',
  },
  reports: {
    root: 'reports/*',
    exampleReport: 'example-report',
    revenueForecast: 'revenue-forecast',
  },
  projectManagement: {
    root: 'ProjectManagement/*',
  },
  pageSettings: {
    root: 'page-settings/*',
    frontPage: 'front-page',
    notFound: 'no-page-settings-found',
  },
  root: '/',
} as const;

export const systemAdminDesignSixPagePath = {
  root: 'Settings/*',
  exchangeRate: 'ExchangeRate/Index',
  invoices: 'Invoices/AccountingPeriod',
} as const;

// export const pageSettingDesignSevenPagePath = {
//   root: 'PersonalPageSettings/*',
//   frontpage: '/Frontpage/AllViews',
// } as const;

export const systemAdminDesignSevenPagePath = {
  root: 'system-administration/*',
  projects: {
    resourceManagement: 'projects/resource-management',
  },
  employees: {
    competences: 'employees/competences',
  },
  general: {
    frontpage: 'general/frontpage',
  },
  invoices: {
    accountingPeriod: 'invoices/newAccountingPeriod',
  },
} as const;

export const TLPPagePath = {
  home: '/Home/FrontPage',
  index: '/Home/Index',
  root: '/',
} as const;

export type TDesignSevenPagePathValue =
  (typeof designSevenPagePath)[keyof typeof designSevenPagePath];
export type TTLPPagePathValue = (typeof TLPPagePath)[keyof typeof TLPPagePath];
